<template>
  <div class="container mt-10">
    <div class="root">
      <v-card>
        <div class="search">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </div>
        <v-data-table
          :headers="headers"
          :items="items"
          :items-per-page="8"
          :search="search"
        >
          <template v-slot:item="row">
            <tr>
              <td style="width:50px">{{ row.item.IsiSerial }}</td>
              <td>{{ row.item.IsiEng }}</td>
              <td>{{ row.item.IsiCh }}</td>
              <td>{{ row.item.IsiEntrust }}</td>
              <td>
                <div v-for="(img, key) in row.item.IscImgTitle" :key="key">
                  {{ img }}
                </div>
              </td>
              <td >{{ row.item.IsiNotice }}</td>
              <td >
                <v-btn
                style="margin-left:100px"
                  class="look"
                  @click="onButtonClickDetail(row.item.IsiSerial)"
                  >查看
                </v-btn>
              </td>
            </tr></template
          >
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      enable: true,
      search: "",
      user: {
        id_number: "",
        password_number: "",
      },
      status: "",
      msg: "",
      headers: [
        { text: "NO", value: "IsiSerial" },
        { text: "檢驗項目英文名稱", value: "IsiEng" },
        { text: "檢驗項目中文名稱", value: "IsiCh" },
        { text: "委託狀態", value: "IsiEntrust" },
        { text: "採檢容器", value: "IscImgTitle" },
        { text: "注意事項", value: "IsiNotice" },
      ],
      items: [],
    };
  },
  methods: {
    onButtonClickDetail(serial) {
      this.$router.push({ name: "detail", params: { serial: serial } });
    },
    onButtonClickUpdate(serial) {
      this.$router.push({ name: "update", params: { serial: serial } });
    },
    onEnableChange(serial, enable) {
      console.log(serial);
      console.log(enable);
      require("isomorphic-fetch");
      fetch(process.env.VUE_APP_DATA_ENABLE, {
        method: "POST",
        body: JSON.stringify({ IsiSerial: serial, Enable: enable }),
      })
        .then((res) => res.json())
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((response) => {
          console.log("Success:", response);
          var status = response.status;
          console.log(status);
          if (status == false) {
            this.items.filter(function (element) {
              if (element["IsiSerial"] == serial) {
                element["IsiEnable"] = !enable;
              }
            });
            alert("更改失敗");
          }
        });
    },

    fetchData() {
      //重設狀態
      this.items = [];
      var api = "";
      //取得該頁面的英文字
      var letter = this.$route.params.letter;
      if (letter != null) {
        api = process.env.VUE_APP_LETTER_API + letter;
      } else {
        api = process.env.VUE_APP_ALL_API;
      }
      require("isomorphic-fetch");
      fetch(api, {
        method: "POST",
        body: JSON.stringify(),
      })
        .then((res) => res.json())
        .catch((error) => {
          console.error("Error:", error);
        })
        .then((response) => {
          console.log("Success:", response.data);
          var data = response.data;
          //抓取每個欄位的資料，並且新建到list中
          for (var i in data) {
            var IsiSerial = "";
            var IsiEng = "";
            var IsiEntrust = "";
            var IsiCh = "";
            var IsiContainer = "";
            var IsiNotice = "";
            var IsiEnable = "";
            var IscImgTitle = "";
            var ImgStatus = data[i]["IsiImgStatus"].trim();
            for (var j in data[i]) {
              if (j == "IsiSerial") {
                IsiSerial = data[i]["IsiSerial"];
              }
              if (j == "IsiEng") {
                IsiEng = data[i]["IsiEng"];
              }
              if (j == "IsiEntrust") {
                IsiEntrust = JSON.parse(data[i]["IsiEntrust"])["IsiEntrust"];
              }
              if (j == "IsiCh") {
                IsiCh = data[i]["IsiCh"];
              }
              if (ImgStatus == "Y") {
                IscImgTitle = data[i]["IscImgTitle"];
              }
              if (j == "IsiNotice") {
                IsiNotice = JSON.parse(data[i]["IsiNotice"])["IsiNotice"];
              }
              if (j == "IsiEnable") {
                if (data[i]["IsiEnable"].trim() == "Y") {
                  IsiEnable = true;
                } else {
                  IsiEnable = false;
                }
              }
            }
            this.items.push({
              IsiSerial: IsiSerial,
              IsiEng: IsiEng,
              IsiEntrust: IsiEntrust,
              IsiCh: IsiCh,
              IsiContainer: IsiContainer,
              IsiNotice: IsiNotice,
              IsiEnable: IsiEnable,
              IscImgTitle: IscImgTitle,
            });
          }
          console.log(this.items);
        });
    },
  },
  created() {},
  mounted() {
    this.fetchData();
  },
  watch: {
    // 如果路由有變化，會再次執行該方法
    $route: "fetchData",
  },
};
</script>

<style>
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child) {
  padding: 0 10px;
}
</style>